import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

type IProps = {
  handleCloseEvent: () => void;
  currentEmojieDetails: any;
  randomOffset: number;
};

const EMOJI_MAP: Record<string, string> = {
  clap: require("../../../../assets/images/clap.png"),
  thumbs_up: require("../../../../assets/images/thumbsup.png"),
  high_five: require("../../../../assets/images/handbye.png"),
  heart: require("../../../../assets/images/heart.png"),
  "100": require("../../../../assets/images/percentage.png"),
  smiley: require("../../../../assets/images/smily.png"),
};

const EmojiePopup = (props: IProps) => {
  const { handleCloseEvent, currentEmojieDetails, randomOffset } = props;
  const data = useSelector((state: any) => state.live.settings?.peersNew);
  const self = useSelector((state: any) => state?.auth?.user);

  const [userName, setUserName] = useState("");
  const [emojiPath, setEmojiPath] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      handleCloseEvent();
    }, 3000);

    return () => clearTimeout(timer);
  }, [handleCloseEvent]);

  useEffect(() => {
    const reactedData = currentEmojieDetails?.user_reaction_data;
    if (!reactedData) return;

    const isSelf = (reactedData?.reacted_by_email || reactedData?.reacted_by) === self?.email;
    const reacted_by_type = reactedData?.reacted_by_type;
    let displayName;
    if (isSelf) {
      displayName = "You";
    } else if (reacted_by_type === "trainer") {
      displayName = "Trainer";
    } else {
      displayName = data?.[reactedData?.reacted_by]?.displayName ||
        reactedData?.reacted_by_name ||
        "";
    }
    setUserName(displayName);

    const reactionType = reactedData.reaction_type;
    setEmojiPath(EMOJI_MAP[reactionType] || "");
  }, [currentEmojieDetails, data, self]);

  if (!emojiPath) return null;


  return (
    <div style={{
      position: "fixed",
      bottom: "100px",
      left: `calc(50% + ${randomOffset}px)`,
      transform: "translateX(-50%)",
      zIndex: 999999999,
      display: "flex",
      alignItems: "center",
      animation: "emojiUp 3s ease-out forwards",
      pointerEvents: "none",
    }}>
      <img src={emojiPath} alt="" style={{ width: "32px", height: "32px" }} />
      <span style={{ color: "white", marginLeft: "8px", fontSize: "12px" }}>
        {userName}
      </span>

      <style>
        {`
          @keyframes emojiUp {
            0% { transform: translateX(-50%) translateY(0); opacity: 1; }
            10% { transform: translateX(-50%) translateY(-60px); }
            20% { transform: translateX(-50%) translateY(-120px); }
            30% { transform: translateX(-50%) translateY(-180px); }
            40% { transform: translateX(-50%) translateY(-240px); }
            50% { transform: translateX(-50%) translateY(-300px); }
            60% { transform: translateX(-50%) translateY(-360px); }
            70% { transform: translateX(-50%) translateY(-400px); opacity: 1; }
            100% { transform: translateX(-50%) translateY(-520px); opacity: 0; }
          }
        `}
      </style>
    </div>
  );
};

export default EmojiePopup;